import { useMemo } from "react"

export interface UseTruncateResult {
  value: string
  isTruncated: boolean
}

/**
 * Hook to truncate text based on a threshold
 * @param text - The text to potentially truncate
 * @param threshold - The character threshold
 * @returns Object containing the value (truncated or original) and truncation status
 */
export function useTruncate(
  text: string,
  threshold: number
): UseTruncateResult {
  return useMemo(() => {
    // Only truncate if text is at least 3 characters longer than threshold
    if (text.length >= threshold + 3) {
      return {
        value: `${text.slice(0, threshold)}...`,
        isTruncated: true
      }
    }

    return {
      value: text,
      isTruncated: false
    }
  }, [text, threshold])
}
